<template>
    <v-container fluid>
        <v-col cols="12" sm="6">
            <v-radio-group v-model="model" row>
                <v-radio label="General" value="general"></v-radio>
                <v-radio label="Louvers" value="louvers"></v-radio>
                <v-radio label="HPL" value="hpl"></v-radio>
                <v-radio label="ACS Aluminum" value="acsAluminum"></v-radio>
            </v-radio-group>
        </v-col>
        <v-data-table
            :headers="headers"
            :items="itemsFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h1 class="mr-4">Value Inputs</h1>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.name`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByName"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.name`]="{ item }">
                <p class="py-0 my-0">
                    {{
                        `${item.name} ${
                            item.weight ? `(${item.weight} kg)` : ''
                        }`
                    }}
                </p>
            </template>
            <template v-slot:[`item.value`]="{ item }">
                <p class="py-0 my-0">
                    {{
                        item.percentage ? item.value : formatNumber(item.value)
                    }}
                </p>
            </template>
            <template v-slot:[`item.units`]="{ item }">
                <div
                    class="d-flex justify-center"
                    v-if="item.currency || item.percentage"
                >
                    <p class="py-0 my-0" v-if="!item.percentage">
                        ({{ item.currency
                        }}{{ item.unit ? `/${item.unit}` : '' }})
                    </p>
                    <p class="py-0" v-else>%</p>
                </div>
                <div v-else>
                    <p class="py-0 my-0">{{ item.unit }}</p>
                </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openEditItem({ item })">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <v-data-table
            v-if="mineralWoolItems.id && model == 'louvers'"
            :headers="mineralWoolHeaders"
            :items="mineralWoolItems.items"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h4 class="mr-4">{{ mineralWoolItems.name }}</h4>
                    </v-col>
                </v-row>
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.price`]="{ item }">
                <p class="py-0 my-0">
                    {{ formatNumber(item.price) }}
                </p>
            </template>
            <template v-slot:[`item.units`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="py-0">
                        ({{ item.currency
                        }}{{ item.unit ? `/${item.unit}` : '' }})
                    </p>
                </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn
                        small
                        icon
                        @click="
                            openEditItem({
                                item,
                                containerKey: 'mineralWoolItems',
                            })
                        "
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <v-data-table
            v-if="prepeintedAluminumSheetItems.id && model == 'louvers'"
            :headers="prepeintedAluminumSheetHeaders"
            :items="prepeintedAluminumSheetItems.items"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h4 class="mr-4">
                            {{ prepeintedAluminumSheetItems.name }}
                        </h4>
                    </v-col>
                </v-row>
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.price`]="{ item }">
                <p class="py-0 my-0">
                    {{ formatNumber(item.value) }}
                </p>
            </template>
            <template v-slot:[`item.action`]="{ item, index }">
                <div class="d-flex justify-center">
                    <v-btn
                        small
                        icon
                        @click="
                            openEditItem({
                                item,
                                index,
                                containerKey: 'prepeintedAluminumSheetItems',
                            })
                        "
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <v-data-table
            v-if="industrialMaterials.length > 0 && model == 'louvers'"
            :headers="industrialMaterialsHeaders"
            :items="industrialMaterials"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h4 class="mr-4">
                            Industrial Materials
                        </h4>
                    </v-col>
                </v-row>
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.action`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn
                        small
                        icon
                        @click="
                            openEditItem({
                                item,
                                containerKey: 'industrialMaterials',
                            })
                        "
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <!--IMPACT RATED LOUVER (ESM-5LS) LABOR COST PER MODULE-->
        <v-divider class="mt-4 mb-1" />
        <LaborCostPerModule v-if="model == 'louvers'" :settingId="setting.id" />
        <v-divider class="mt-4 mb-1" />
        <LouverSizingTable v-if="model == 'louvers'" :settingId="setting.id" />
        <!--PRICES LAMITECH COST PER MODULE-->
        <v-divider class="mt-4 mb-1" />
        <PricesLamitechModule v-if="model == 'hpl'" :settingId="setting.id" />
        <!--FORM-->
        <v-dialog
            v-model="openItemForm"
            :retain-focus="false"
            persistent
            width="600px"
        >
            <ValueInputForm
                v-if="openItemForm"
                :createForm="createForm"
                :item="selectedItem"
                :originalItem="originalItem"
                :setting="setting"
                :category="category"
                :specialItem="specialItem"
                @addItem="addItem"
                @replaceItem="replaceItem"
                @replaceSpecialItem="replaceSpecialItem"
                @replaceIndustrialMaterials="replaceIndustrialMaterials"
                @close="closeEditItem"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import API from '@/services/api'

export default {
    name: 'ValueInputs',
    props: {
        setting: {
            type: Object,
            required: true,
        },
    },
    components: {
        ValueInputForm: () => import('./ValueInputForm.vue'),
        LaborCostPerModule: () => import('./LaborCostPerModule.vue'),
        LouverSizingTable: () => import('./LouverSizingTable.vue'),
        PricesLamitechModule: () => import('./PricesLamitechModule.vue'),
    },
    data: () => ({
        specialItem: null,
        category: null,
        mineralWoolItems: {},
        prepeintedAluminumSheetItems: {},
        mineralWool: 'h9rCzioCCUv8tZH1TQGZ',
        prepeintedAluminumSheet: 'TsPK3WmtC7MoTgzNfDmR',
        idMineralWoolDimensions: 'nQPiZp17yDPJZyALxHm5',
        aluminumSheetAccessories: 'AjCy2o2E7EMqvmMJeaii',
        aluminumMeshForBirdScreen: '72yJrloMzc0rJZnCzAC9',
        aluminumMeshForInsectScreen: 'ZQPEgvgiXVN7UgBH0nDC',
        aluminumSheetBrakeMetalInternal: '0S88sij8CwQVObdNNIyH',
        industrialMaterials: [],
        loading: false,
        items: [],
        selectedItem: {},
        originalItem: {},
        createForm: true,
        openItemForm: false,
        headers: [
            {
                text: 'NAME',
                value: 'name',
                sortable: false,
            },
            {
                text: 'MODEL',
                value: 'model',
                sortable: false,
                align: 'center',
                default: '5LS',
            },
            {
                text: 'VALUE',
                value: 'value',
                sortable: false,
                align: 'center',
            },
            {
                text: 'UNITS',
                value: 'units',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ACTION',
                value: 'action',
                sortable: false,
                align: 'center',
            },
        ],
        mineralWoolHeaders: [
            {
                text: 'REFERENCE',
                value: 'reference',
                sortable: false,
            },
            {
                text: 'INCHES',
                value: 'inches',
                sortable: false,
                align: 'center',
            },
            {
                text: 'PRICE',
                value: 'price',
                sortable: false,
                align: 'center',
            },
            {
                text: 'UNITS',
                value: 'units',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ACTION',
                value: 'action',
                sortable: false,
                align: 'center',
            },
        ],
        prepeintedAluminumSheetHeaders: [
            {
                text: 'LENGTH',
                value: 'length',
                sortable: false,
            },
            {
                text: 'WIDTH',
                value: 'width',
                sortable: false,
                align: 'center',
            },
            {
                text: 'THICKNESS',
                value: 'thickness',
                sortable: false,
                align: 'center',
            },
            {
                text: 'PRICE',
                value: 'value',
                sortable: false,
                align: 'center',
            },
            {
                text: 'UNIT',
                value: 'unit',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ACTION',
                value: 'action',
                sortable: false,
                align: 'center',
            },
        ],
        industrialMaterialsHeaders: [
            {
                text: 'NAME',
                value: 'name',
                sortable: false,
                align: 'left',
            },
            {
                text: 'LENGTH',
                value: 'length',
                sortable: false,
                align: 'center',
            },
            {
                text: 'WIDTH',
                value: 'width',
                sortable: false,
                align: 'center',
            },
            {
                text: 'THICKNESS',
                value: 'thickness',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ACTION',
                value: 'action',
                sortable: false,
                align: 'center',
            },
        ],
        searchByName: undefined,
        model: 'general',
    }),
    computed: {
        itemsFiltered() {
            const conditions = []
            if (this.searchByName) {
                conditions.push(this.filterByName)
            }
            if (this.model) {
                conditions.push(this.filterByModel)
            }
            this.sort()
            if (conditions.length > 0) {
                return this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            return this.items
        },
    },
    async mounted() {
        try {
            this.loading = true
            const items = await API.getAllValueInputs(this.setting.id)
            let valueInputs = []
            for (const item of items) {
                if (
                    item.id != this.mineralWool &&
                    item.id != this.prepeintedAluminumSheet &&
                    item.id != this.idMineralWoolDimensions &&
                    item.id != this.aluminumSheetAccessories &&
                    item.id != this.aluminumMeshForBirdScreen &&
                    item.id != this.aluminumMeshForInsectScreen &&
                    item.id != this.aluminumSheetBrakeMetalInternal
                ) {
                    valueInputs.push(item)
                } else if (item.id == this.mineralWool) {
                    this.mineralWoolItems = item
                } else if (item.id == this.prepeintedAluminumSheet) {
                    this.prepeintedAluminumSheetItems = item
                } else if (
                    item.id == this.idMineralWoolDimensions ||
                    item.id == this.aluminumSheetAccessories ||
                    item.id == this.aluminumMeshForBirdScreen ||
                    item.id == this.aluminumMeshForInsectScreen ||
                    item.id == this.aluminumSheetBrakeMetalInternal
                ) {
                    this.industrialMaterials.push(item)
                }
            }
            this.items = valueInputs
        } catch (error) {
            this.setErrorItems({
                name: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE').format(number || 0)
        },
        filterByName(item) {
            return item.name
                .toLowerCase()
                .includes(this.searchByName.toLowerCase())
        },
        filterByModel(item) {
            switch (this.model) {
                case 'general':
                    return !item.model
                case 'hpl':
                    return item.model && item.model.toLowerCase() === 'hpl'
                case 'louvers':
                    return (
                        item.model &&
                        item.model.toLowerCase() !== 'hpl' &&
                        item.model.toLowerCase() !== 'acs aluminum' &&
                        item.model.toLowerCase() !== 'brake metals'
                    )
                case 'acsAluminum':
                    return (
                        item.model &&
                        item.model.toLowerCase() === 'acs aluminum'
                    )
                default:
                    return false
            }
        },

        replaceItem(itemToUpdate) {
            const index = this.items.findIndex(
                item => item.id == itemToUpdate.id
            )
            if (index >= 0) {
                this.items.splice(index, 1, {
                    ...this.items[index],
                    ...itemToUpdate,
                })
            }
        },
        replaceIndustrialMaterials({ itemToUpdate }) {
            const index = this.industrialMaterials.findIndex(
                item => item.id == itemToUpdate.id
            )
            if (index >= 0) {
                this.industrialMaterials.splice(index, 1, {
                    ...this.industrialMaterials[index],
                    ...itemToUpdate,
                })
            }
        },
        addItem(item) {
            this.items.push(item)
            this.searchByName = ''
        },
        sort() {
            this.items.sort((a, b) => a.name.localeCompare(b.name))
        },
        closeEditItem() {
            this.createForm = true
            this.selectedItem = {}
            this.originalItem = {}
            this.openItemForm = false
            this.specialItem = null
        },
        openEditItem({ item, index = null, containerKey = null }) {
            if (containerKey && index != null) {
                this.specialItem = {
                    selectedIndex: index,
                    ...this[containerKey],
                }
            }
            this.createForm = false
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
            this.category = containerKey
            this.openItemForm = true
        },
    },
}
</script>

<style>
thead {
    position: sticky;
    z-index: 2;
}
</style>
